import { FaTimes } from "react-icons/fa";

const CLOTH_WEIGHT_DATA = [
  { type: "Shirt / T-Shirt", weight: "0.2 – 0.3 lbs" },
  { type: "Jeans / Trouser", weight: "0.6 – 0.8 lbs" },
  { type: "Jacket / Hoodie", weight: "1.0 – 1.5 lbs" },
  { type: "Bedsheet (Single)", weight: "1.2 – 1.6 lbs" },
  { type: "Bedsheet (Double)", weight: "2.0 – 2.5 lbs" },
  { type: "Comforter", weight: "3.0 – 5.0 lbs" },
  { type: "Blanket", weight: "4.0 – 6.0 lbs" },
  { type: "Curtains (Pair)", weight: "3.0 – 4.0 lbs" },
];

export default function ClothWeightInfoModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-md rounded-2xl border border-[#D8DAE5] shadow-xl">

        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-[#D8DAE5]">
          <h2 className="text-base font-semibold text-[#1F2937]">
            Clothes Weight Guide
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F7F8F9] text-[#64748B] hover:bg-[#DEEDF6]"
          >
            <FaTimes size={12} />
          </button>
        </div>

        {/* Content */}
        <div className="px-5 py-4">
          <div className="rounded-xl overflow-hidden border border-[#D8DAE5]">
            <table className="w-full text-sm">
              <thead className="bg-[#DEEDF6] text-[#1876A9]">
                <tr>
                  <th className="px-4 py-2 text-left font-semibold">
                    Cloth Type
                  </th>
                  <th className="px-4 py-2 text-right font-semibold">
                    Approx Weight
                  </th>
                </tr>
              </thead>
              <tbody>
                {CLOTH_WEIGHT_DATA.map((item, idx) => (
                  <tr
                    key={idx}
                    className="border-t border-[#D8DAE5] hover:bg-[#F7F8F9]"
                  >
                    <td className="px-4 py-2 text-[#1F2937]">
                      {item.type}
                    </td>
                    <td className="px-4 py-2 text-right font-medium text-[#1876A9]">
                      {item.weight}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="text-xs text-[#64748B] mt-3">
            *Weights are approximate and may vary by fabric & size.
          </p>
        </div>
      </div>
    </div>
  );
}
